import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { IcoArrowRightSmall16 } from '@onefootprint/icons';
import type { AmlHitMedia } from '@onefootprint/request-types/dashboard';
import { LinkButton } from '@onefootprint/ui';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TruncatedText from '@/entities/components/details/components/truncated-text';
type HitsMediaProps = {
  mediaList: AmlHitMedia[];
};
const HitsMedia = t0 => {
  const $ = _c(9);
  const {
    mediaList
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.riskSignals.drawer.hitsMedia"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    formatDateWithShortMonth
  } = useIntl();
  const firstMediaRef = useRef(null);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      firstMediaRef.current?.scrollIntoView();
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const renderMediaRow = _temp;
  let t4;
  if ($[3] !== formatDateWithShortMonth || $[4] !== mediaList || $[5] !== t) {
    t4 = mediaList.map((media, index) => {
      const {
        date,
        title,
        snippet,
        url
      } = media;
      return <div key={JSON.stringify(media)} ref={index === 0 ? firstMediaRef : null} role="group" className="flex flex-col gap-5 py-5 border-b border-dashed first:pt-0 text-body-2 border-b-tertiary last:border-b-0 last:pb-0">{renderMediaRow(t(_temp2), date ? formatDateWithShortMonth(new Date(date)) : "-")}{renderMediaRow(t(_temp3), title ?? "-")}{snippet && <div className="flex flex-col gap-2"><p className="text-left text-body-2 text-tertiary w-fit">{t(_temp4)}</p><TruncatedText text={snippet} truncatedTextNumLines={6} className="text-body-2" /></div>}{url && <LinkButton iconComponent={IcoArrowRightSmall16} iconPosition="right" href={url} target="_blank">{t(_temp5)}</LinkButton>}</div>;
    });
    $[3] = formatDateWithShortMonth;
    $[4] = mediaList;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="flex flex-col mt-2">{t4}</div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default HitsMedia;
function _temp(label, value) {
  return <div className="flex flex-col gap-1"><p className="text-label-2 text-tertiary">{label}</p><div className="overflow-hidden whitespace-nowrap text-ellipsis">{value}</div></div>;
}
function _temp2($) {
  return $.date;
}
function _temp3($_0) {
  return $_0.title;
}
function _temp4($_1) {
  return $_1.snippet;
}
function _temp5($_2) {
  return $_2.url;
}